import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import textLabel from '../textLabel/textLabel';
import symbol from '../symbol/symbol';
import textTypes from '../textLabel/textTypes';

var ButtonContent = function ButtonContent(props) {
  return /*#__PURE__*/React.createElement('div', {
    className: 'control-button-content'
  }, props.symbol ? /*#__PURE__*/React.createElement(symbol, {}, props.symbol) : null, /*#__PURE__*/React.createElement(textLabel, {
    value: props.value,
    type: props.type,
    shouldTranslate: props.shouldTranslate
  }));
};

ButtonContent.displayName = displayNames.BUTTON_CONTENT;
ButtonContent.propTypes = {
  value: PropTypes.string.isRequired,
  symbol: PropTypes.element,
  type: PropTypes.oneOf(textTypes.TYPES)
};
ButtonContent.defaultProps = {
  type: 'T01'
};
export default compose(ButtonContent);